import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { path_module_public } from '@app/models/routes.name';
import { environment } from '@env/environment';

@Component({
  selector: 'job-card',
  templateUrl: './job-card.component.html',
  styleUrls: ['./job-card.component.css']
})
export class JobCardComponent implements OnInit {

  @Input() job: any = {};
  @Input() tabNextSeason: boolean = true;
  @Input() showInfoInstitution: boolean = true;
  @Output() eventApplication = new EventEmitter<any>();


  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateToJobView(event: MouseEvent) {

    event.preventDefault();

    const url = `${environment.basePath}/${path_module_public.advice}/${this.job.jobId}`

    window.open(url, '_blank');
  }

  setJobApply(event: MouseEvent) {
    event.preventDefault();
    this.eventApplication.next(this.job);
  }

}
